import { CSSProperties, ReactNode, useState } from 'react';
import AgTypography from '../../../Styles/AgTypography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { AgColor } from '../../../Styles/AgColor';

export interface AgBaseCardProps {
  title?: string;
  width?: string;
  height?: string;
  children?: ReactNode;
  message?: string;
  style?: CSSProperties;
  closeIcon?: boolean;
}

const AgInfoCard = (
  {
    title,
    width = '216px', //by default
    height,
    children, // for multiple paragraph
    message, // message for 1 paragraph
    style,
    closeIcon = true
  }: AgBaseCardProps) => {
  const [open, setOpen] = useState<boolean>(true);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <AgTypography
      style={{
        display: open ? 'flex' : 'none',
        flexDirection: 'column',
        padding: '16px',
        width: width,
        height: height,
        boxSizing: 'border-box',
        gap: '8px',
        borderRadius: '8px',
        backgroundColor: AgColor.primaryLight2,
        boxShadow: '0px 1px 2px 0px #0000000D',
        ...style,
        maxWidth: '560px' //max width requirement
      }}
    >
      <AgTypography
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: AgColor.primaryLight,
          position: 'relative'
        }}
      >
        <AgTypography
          style={{
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'normal',
            gap: '4px'
          }}
        >
          <InfoOutlinedIcon style={{ fontSize: '18px', color: AgColor.primaryLight }} />
          <AgTypography
            contentStyle={'AP.H4.Bold'}
            style={{
              display: 'flex',
              flexDirection: 'column',
              color: AgColor.primaryLight,
              gap: '16px',
              wordWrap: 'break-word',
              maxWidth: `calc(${width} - 70px)`
            }}
          >
            {title}
          </AgTypography>
        </AgTypography>
        {closeIcon && (<AgTypography onClick={handleClose}>
          <CloseOutlinedIcon
            style={{
              fontSize: '18px',
              cursor: 'pointer',
              color: AgColor.primaryMain,
              position: 'absolute',
              top: '0',
              right: '0'
            }}
          />
        </AgTypography>)}
      </AgTypography>
      <AgTypography
        contentStyle={'AP.H5.Medium'}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          wordWrap: 'break-word'
        }}
      >
        {message}
        {children}
      </AgTypography>
    </AgTypography>
  );
};

export default AgInfoCard;